import React, {useState } from 'react';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import OwlCarousel from 'react-owl-carousel';
import CountUp from 'react-countup';

const CounterCarousel = () => {
  const [animated] = useState(false);

  // Sample data for counters
  const counters = [
    { number: 100, text: 'Projects delivered' },
    { number: 12, text: 'Years of service excellence' },
    { number: 400, text: 'Happy Customers' },
  ];


  return (
    <div className="counter-section">
      <OwlCarousel className="owl-theme countercarousel">
        {counters.map((counter, index) => (
          <div key={index} className="item">
            <div className="counterbox">
              {typeof counter.number === 'number' ? (
                <strong className={`text-2xl text-white ${animated ? 'animate-bounce' : ''}`}>
                  <CountUp end={counter.number} duration={10} /><span>+</span>
                </strong>
              ) : (
                <strong className="text-2xl text-white">{counter.number}  </strong>
              )}
              <br />
              <span className='text-xl text-white'>{counter.text} </span> 
            </div>
          </div>
        ))}
      </OwlCarousel>
    </div>
  );
};

export default CounterCarousel;
